import { createAppUrl } from '../utils'

let publicToken = null;

export const getPublicToken = () => publicToken

export const setPublicToken = token => {
    publicToken = token;
}

export const getPublicUrl = (token, suffix) => {
    return `${createAppUrl()}/public/${token}/${suffix}`;
}
